// sessionStore.js
const sessionStore = {
    /**
     * 保存数据到 sessionStorage
     * @param {string} key 键名
     * @param {any} value 值，可以是对象、数组、基本类型、大整数（建议大整数传字符串）
     */
    set(key, value) {
        try {
            let val;
            if (typeof value === 'string') {
                val = value;
            } else if (typeof value === 'number') {
                // 超过安全整数范围的数字强制转为字符串
                val = Number.isSafeInteger(value) ? value.toString() : value.toString();
            } else {
                val = JSON.stringify(value);
            }
            sessionStorage.setItem(key, val);
        } catch (error) {
            console.error(`sessionStore set error [${key}]:`, error);
        }
    },

    /**
     * 从 sessionStorage 获取数据
     * 尝试解析 JSON，如果失败返回字符串
     * @param {string} key 键名
     * @param {any} defaultValue 默认值
     * @returns {any}
     */
    get(key, defaultValue = null) {
        try {
            const val = sessionStorage.getItem(key);
            if (val === null) return defaultValue;

            // 判断是否是 JSON 字符串（对象/数组）
            if ((val.startsWith('{') && val.endsWith('}')) || (val.startsWith('[') && val.endsWith(']'))) {
                try {
                    return JSON.parse(val);
                } catch {
                    return val; // 解析失败返回原始字符串
                }
            }
            return val; // 普通字符串
        } catch (error) {
            console.error(`sessionStore get error [${key}]:`, error);
            return defaultValue;
        }
    },

    /**
     * 获取字符串类型
     * @param {string} key
     * @param {string} defaultValue
     * @returns {string}
     */
    getString(key, defaultValue = '') {
        const val = this.get(key, defaultValue);
        return typeof val === 'string' ? val : JSON.stringify(val);
    },

    /**
     * 获取 JSON 类型
     * @param {string} key
     * @param {any} defaultValue
     * @returns {object|array|null}
     */
    getJSON(key, defaultValue = null) {
        const val = this.get(key, defaultValue);
        if (typeof val === 'string') {
            try {
                return JSON.parse(val);
            } catch {
                return defaultValue;
            }
        }
        return val;
    },

    remove(key) {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
            console.error(`sessionStore remove error [${key}]:`, error);
        }
    },

    clear() {
        try {
            sessionStorage.clear();
        } catch (error) {
            console.error('sessionStore clear error:', error);
        }
    }
};

export default sessionStore;